export default [
  {
    path: "",
    redirect: "colors",
  },
  {
    path: "colors",
    component: () => import("@/views/design-system/Colors.vue"),
  },
  {
    path: "typography",
    component: () => import("@/views/design-system/Typography.vue"),
  },
  {
    path: "forms",
    component: () => import("@/views/design-system/Forms.vue"),
  },
  {
    path: "buttons",
    component: () => import("@/views/design-system/Buttons.vue"),
  },
]
